import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Sidebar from "../../components/dashboard/Sidebar";
import DashboardHeader from "../../components/dashboard/HeaderDashboard";
import StudySettings from "../../components/createStudy/StudySettings";
import { Grid, Settings, Bell, HelpCircle } from "lucide-react";
import SiteSettings from "../../components/createStudy/SiteSettings";
import RoleManagement from "../../components/createStudy/RoleManagement";
import State, { STATE, CurrentEntityState, CurrentStudyState } from "@state";
import NavigationService from "@/network/services/navigation.service";

export default function CreateStudy() {
  const navigateTo = NavigationService.navigateTo;

  console.log("=== STATE === CreateStudy.jsx === key: 278063 ===");
  console.dir(STATE, { depth: null, colors: true });
  console.log("=================================");

  const [currentStep, setCurrentStep] = useState(1);
  /** ------------------ cmt 253636 ------------------
  const studyModel = {
    tmpId: "",
    name: "",
    estimatedDuration: "",
    thresholdOfParticipants: "",
    croId: "",
    masterIcfs: [],
    cros: [],
  };
  *-------------------------------------------------*/
  
  const [refresh, setRefresh] = useState(0);

  const stateKeys = [
    CurrentEntityState.CURRENT_ENTITY_ID,
    CurrentEntityState.CURRENT_ENTITY_DATA,
    CurrentStudyState.STUDY,
    CurrentStudyState.MASTER_ICFS,
    CurrentStudyState.SITES,
    CurrentStudyState.CROS,
    CurrentStudyState.CRO_MANAGERS,
    CurrentStudyState.INVESTIGATORS,
    CurrentStudyState.MILESTONES,
  ];

  useEffect(() => {
    State.reset(CurrentStudyState);
    const onStateChange = () => setRefresh((v) => v + 1);
    stateKeys.forEach((key) => State.registerListener(key, onStateChange));
    return () => {
      stateKeys.forEach((key) => State.unregisterListener(key, onStateChange));
    };
      
  }, []);

  const handleNextStep = () => {
    setCurrentStep((prev) => prev + 1);
  };

  const handlePrevStep = () => {
    setCurrentStep((prev) => prev - 1);
  };

  // Render the current step
  const renderStep = () => {
    switch (currentStep) {
      case 1:
        return (
          <StudySettings
            onNext={handleNextStep}
          />
        );
      case 2:
        return (
          <SiteSettings
            onNext={handleNextStep}
            /*onPrev={handlePrevStep}*/
          />
        );
      case 3:
        return (
          <RoleManagement
            onNext={handleNextStep}
            onPrev={handlePrevStep}
          />
        );
      default:
        return <div>Unknown step</div>;
    }
  };

  return (
    <div className="flex h-screen bg-dashboard-bg">
      {/* Sidebar */}
      <Sidebar activeLink="Dashboard" />

      {/* Main content */}
      {STATE[CurrentEntityState.CURRENT_ENTITY_ID] === null ? (
        <div className="flex h-screen bg-dashboard-bg">Entity not found</div>
      ) : (
        <div className="flex-1 flex flex-col overflow-hidden p-4">
          {/* Header with title */}

          {/* Main content area with rounded corners and spacing - FIXED OVERFLOW */}
          <div className="flex-1 mt-2 overflow-auto">
            <main className="p-4">
              <h2 className="text-2xl font-bold mb-6">Create new study</h2>
              <div className="rounded-xl bg-dashboard-bg1 p-6">
                {renderStep()}
              </div>
            </main>
          </div>
        </div>
      )}
    </div>
  );
}
